export function warehouseWorkMethodLabel(method?: string): string {
  switch (method) {
    case 'DESKTOP_BULK': return 'Bulk confirmation';
    case 'DESKTOP_MANUAL': return 'Manual confirmation';
    case 'DESKTOP_SCAN': return 'Individual scan';
    default: return method || 'Legacy';
  }
}
